import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ed4c444&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1ed4c444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4c444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed4c444')) {
      api.createRecord('1ed4c444', component.options)
    } else {
      api.reload('1ed4c444', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1ed4c444&scoped=true&", function () {
      api.rerender('1ed4c444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/drawer/index.vue"
export default component.exports